<template>
  <div class="rule-form-field">
    <b-form-select
      :name="name"
      v-if="isSelectBox"
      :value="value"
      @input="onInput"
      :options="options"
    >
    </b-form-select>
    <b-form-input
      :name="name"
      v-if="isTextBox || isNumber"
      :type="isNumber ? 'number': 'text'"
      class="form-control"
      :value="value"
      @input="onInput"
    >
    </b-form-input>
    <span v-if="isLabel">
      <strong>
        <i style="color: green; font-size: 1.25rem;margin-top: 10px;margin-left: 1px;" class="fal fa-check-circle"></i>
      </strong>
    </span>
  </div>
</template>

<script>
import { INVOICE_RULES } from '@/app-constant';
import AppForm from '@/components/app-form/';
import AppAutoComplete from '@/components/app-autocomplete/';

export default {
  name: 'RuleFormField',
  components: {
    AppForm,
    AppAutoComplete,
  },
  props: {
    name: String,
    type: String,
    value: [Object, Array, String, Number],
    options: Array,
  },
  data() {
    return {
    };
  },
  computed: {
    isLabel() {
      return [
        'INVOICE_RULES.FUTURE_RULE',
      ].indexOf(this.type) > -1;
    },
    isSelectBox() {
      return [
        INVOICE_RULES.RULE_UNIT,
        INVOICE_RULES.RULE_KIND_OF,
        INVOICE_RULES.RULE_PAID_DATE,
      ].indexOf(this.type) > -1;
    },
    isNumber() {
      return [
        INVOICE_RULES.RULE_VAT,
        INVOICE_RULES.RULE_VAT_LEAST,
        INVOICE_RULES.RULE_VAT_MOST,
        INVOICE_RULES.RULE_TOTAL_BEFORE_TAX,
        INVOICE_RULES.RULE_TOTAL_BEFORE_TAX_LEAST,
        INVOICE_RULES.RULE_TOTAL_BEFORE_TAX_MOST,
        INVOICE_RULES.RULE_AMOUNT_OF_DEBT_DAYS,
      ].indexOf(this.type) > -1;
    },
    isTextBox() {
      return [
        INVOICE_RULES.RULE_CCID,
        INVOICE_RULES.RULE_SELLER,
        INVOICE_RULES.RULE_BUYER,
        INVOICE_RULES.RULE_CONTENT,
      ].indexOf(this.type) > -1;
    },
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event instanceof InputEvent ? $event.target.value : $event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/rule/rule-form-field.vue